import React from 'react';
import ApplicationListTable from 'src/ui-component/ApplicationListTable/Index';
import { Container, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Breadcrumb from 'src/ui-component/Breadcrumb';

const ApplicationList: React.FC = () => {
  
  const location = useLocation();
  const isDraft = location.pathname.split('/').pop() === 'draft-application';
  const columns = [
    'Application Number',
    'Business Name',
    'Owner Name',
    'Last Activity Date',
    'Status',
    'Actions'
  ];

  return (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Clerk Vending'}
        PageTitle={`${isDraft ? 'Draft' : 'All'} Applications`}
      />
      <Box mt={2}>
        <ApplicationListTable columns={columns} isDraft={isDraft} />
      </Box>
    </Container>
  );
};

export default ApplicationList;
